import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNaFlag = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 50,
	height: 50,
	viewBox: "0 0 50 50",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_1339_53711)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M-0.000488281 33.6207V9.48271C-0.000488281 9.00664 0.385547 8.62061 0.861621 8.62061H37.9306L-0.000488281 33.6207Z",
					fill: "#41479B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M49.9999 16.3794V40.5173C49.9999 40.9934 49.6139 41.3794 49.1378 41.3794H12.0688L49.9999 16.3794Z",
					fill: "#73AF00"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M49.9995 16.8654V9.48271C49.9995 9.00664 49.6135 8.62061 49.1374 8.62061H37.4154L-0.000488281 33.1346V40.5172C-0.000488281 40.9933 0.385547 41.3793 0.861621 41.3793H12.5836L49.9995 16.8654Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M49.9995 13.7741V9.48271C49.9995 9.00664 49.6135 8.62061 49.1374 8.62061H42.1337L-0.000488281 36.2259V40.5173C-0.000488281 40.9934 0.385547 41.3794 0.861621 41.3794H7.86533L49.9995 13.7741Z",
					fill: "#CD343C"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M8.81016 14.2474C9.65889 14.2474 10.4271 14.5912 10.9834 15.1472L11.2886 13.0294L9.60547 14.3537L8.81006 12.3652L8.01465 14.3537L6.33154 13.0294L6.63672 15.1472C7.19326 14.5911 7.96143 14.2474 8.81016 14.2474Z",
					fill: "#FFE15A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M6.63545 19.4955C6.07949 18.9392 5.73564 18.1708 5.73564 17.3223C5.73564 16.4735 6.07949 15.7054 6.63545 15.149L4.51768 14.8438L5.84199 16.5269L3.85352 17.3223L5.84199 18.1177L4.51768 19.8008L6.63545 19.4955Z",
					fill: "#FFE15A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M13.7673 17.3222L11.7788 16.5268L13.1031 14.8438L10.9854 15.1489C11.5413 15.7053 11.8852 16.4736 11.8852 17.3222C11.8852 18.1708 11.5413 18.9391 10.9854 19.4954L13.1031 19.8006L11.7788 18.1175L13.7673 17.3222Z",
					fill: "#FFE15A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M8.81045 20.3969C7.96172 20.3969 7.19355 20.053 6.63721 19.4971L6.33203 21.6148L8.01514 20.2905L8.81055 22.279L9.60596 20.2905L11.2891 21.6148L10.9839 19.4971C10.4273 20.0531 9.65918 20.3969 8.81045 20.3969Z",
					fill: "#FFE15A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M8.81045 19.8328C10.197 19.8328 11.3211 18.7088 11.3211 17.3222C11.3211 15.9356 10.197 14.8115 8.81045 14.8115C7.42386 14.8115 6.2998 15.9356 6.2998 17.3222C6.2998 18.7088 7.42386 19.8328 8.81045 19.8328Z",
					fill: "#FFE15A"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_1339_53711",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 50,
				height: 50,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgNaFlag);
export { ForwardRef as ReactComponent };
